export default __webpack_public_path__ + "static/media/trolley-marker-away.094b7ab6.svg";